import { cn } from "@newxsystems/shared";
import { SproutAction } from "../SproutAction/SproutAction";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const widths = { small: "w-2/3", medium: "w-5/6", large: "w-full" } as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => (
  <div className="grid grid-cols-1 items-center gap-7 md:grid-cols-2 md:gap-12">
    {eyebrow ? (
      <p className="order-1 w-fit -rotate-1 rounded-lg bg-whiteboard px-3 py-2 font-sprout-mono text-sm font-extrabold text-navy-ink md:col-start-1">
        {eyebrow}
      </p>
    ) : null}
    {image ? (
      <SproutMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className={cn(
          "order-2 justify-self-end md:col-start-2 md:row-span-4 md:row-start-1",
          widths[imageWidth || "medium"],
        )}
        media={image.image}
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    ) : null}
    {heading ? (
      <h2 className="order-3 font-sprout-display text-4xl font-bold leading-[0.98] tracking-[-0.025em] [overflow-wrap:anywhere] md:col-start-1 md:text-6xl">
        {heading}
      </h2>
    ) : null}
    {description ? (
      <SproutRichText
        className="order-4 max-w-[65ch] text-navy-ink md:col-start-1"
        content={description}
      />
    ) : null}
    {buttons?.length ? (
      <div
        className={cn(
          "order-5 flex flex-wrap gap-3",
          image
            ? "md:col-start-1"
            : "md:col-start-2 md:row-span-3 md:row-start-1 md:justify-self-end",
        )}
      >
        {buttons.map((button, index) => (
          <SproutAction action={button} key={`${button.href}-${index}`} />
        ))}
      </div>
    ) : null}
  </div>
);

CallToActionSplit.displayName = "Content::CallToActionSplit";
